// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'csr-agent';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.467 1.913a6.75 6.75 0 0 1 1.688 12.375v3.15' />
    <path d='M9.78 11.25a2.812 2.812 0 1 0 0-5.625 2.812 2.812 0 0 0 0 5.625z' />
    <path d='M8.092 6.188V1.125a.562.562 0 0 1 .563-.563h2.25a.57.57 0 0 1 .562.563v5.063m-9.142 5.46a1.124 1.124 0 0 1-.66-1.718L3 7.883V7.32c0-2.655 2.145-4.882 5.062-5.475M6.405 17.437V16.32M9.75 8.438a5.625 5.625 0 0 1-5.625 5.624H3' />
  </g>
);

export const viewBox = '0 0 18 18';
